module.exports = "<div class=\"c-breadcrumb__bar\">\n    <div class=\"c-breadcrumb__element\">\n        <span class=\"c-breadcrumb__element-item\" *ngFor=\"let map of breadcrumbs\">\n        <a *ngIf=\"map.link\" [routerLink]=\"[map.link]\">\n          {{map.title}}\n        </a>\n         <span *ngIf=\"!map.link\">\n         {{map.title}}\n         </span>\n        </span>\n    </div>\n    <ng-content></ng-content>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/breadcrumb/breadcrumb.component.html
// module id = ./src/app/modules/common-module/components/breadcrumb/breadcrumb.component.html
// module chunks = 9